import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Admin from "./components/Admin";
import Name from "./components/Name";
import Forgot from "./components/ChangePass";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("userdetails"));

  localStorage.setItem("manualLogout", "true");

  const manualLogout = localStorage.getItem("manualLogout") === "true";
  if (!user) {
    if (!manualLogout) {
      alert("Session expired or not logged in. Redirecting to login.");
    }
    localStorage.removeItem("manualLogout"); // clear the flag
    return <Navigate to="/" replace />;
  }

  return children;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("userdetails");
    setIsLoggedIn(!!user);

    // if (user) {
    //   setIsLoggedIn(true);
    // }
  }, []);

  return (
    <div className="app">
      <Router>
        <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route
              path="/Admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/layamA"
              element={
                <ProtectedRoute>
                  <Name />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Forgot"
              element={
                <ProtectedRoute>
                  <Forgot />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
};

export default App;
